import React from 'react';
import { useDocumentTitle } from "usehooks-ts";
import { msg } from "src/app/msg";
import Div from "nood-comp/src/comp/ui/containers/Div";
import CountWidget from "nood-comp/src/comp/widget/CountWidget";
export default function AdminHome(props) {
  useDocumentTitle(msg.title('Home'));
  return /*#__PURE__*/React.createElement(Div, {
    pad: 20
  }, /*#__PURE__*/React.createElement(CountWidget, {
    caption: "Signup Requests",
    to: "/orgs?pg=invite-requests&status=NEW",
    initialWidth: "M",
    entity: "RequestInvite",
    predicate: {
      'f': [{
        property: 'status',
        value: 'NEW',
        comparator: '=='
      }]
    }
  }));
}